import React from 'react';
import InlineFeedbackBase from './InlineFeedbackBase';

import TInlineFeedback from './types/TInlineFeedback';
import { FeedbackSignals } from '../../types/TEFeedbackSignal';

const Info = ({ children, ...rest }: TInlineFeedback) => (
  <InlineFeedbackBase {...rest} signal={FeedbackSignals.Info}>
    {children}
  </InlineFeedbackBase>
);

export default Info;
